<template>
  <div :class="widgetData.container">
    <div class="row" v-if="widgetData.description">
      <div class="col-12">
        <div class="section-title">
          <div v-html="widgetData.description"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ClientOnly>
          <div v-html="content"></div>
          <template slot="fallback" v-html="widgetData.text_field"/>
        </ClientOnly>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useWidget} from "~/composables/widget/textfield";
import {PropType} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {widgetData, content} = useWidget(props.widget);
</script>
